/** Type-aware i18n key for an address purpose.
 *
 * A Contact is either a person or a legal entity (`is_business`), so its own
 * main address (`purpose=beneficiary`) reads as either the beneficiary's
 * address or the company's registered office — same stored purpose, different
 * label. Worksite / billing / other are unaffected. Kept in a plain module
 * (not a .tsx) so the component files only export components. */
export function addressPurposeLabelKey(
  purpose: string,
  isBusiness?: boolean,
): string {
  return isBusiness && purpose === "beneficiary"
    ? "contacts.addresses.purpose_beneficiary_company"
    : `contacts.addresses.purpose_${purpose}`;
}
